import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '../context/AuthContext'
import type { PermissionKey } from '../config/permissions'
import { loadingClass } from '../lib/ui'

export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionKey | string
  children: ReactNode
}) {
  const { can, loading } = useAuth()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!can(permission)) {
    return <Navigate to="/admin/administration/panel" replace />
  }

  return <>{children}</>
}
